import { gql } from "@apollo/client";

const OBJECTIVE_FRAGMENT = gql`
  fragment OBJECTIVE_FRAGMENT on ObjectiveType {
    id
    description
    notes
    dueDate
    keyResults {
      id
      description
      notes
      dueQuarter
      weight
      status
    }
  }
`;

export const FETCH_OBJECTIVE_YEARS = gql`
  query FETCH_OBJECTIVE_YEARS {
    objectiveYears
  }
`;

export const SAVE_OBJECTIVE = gql`
  mutation SAVE_OBJECTIVE(
    $id: ID
    $teamId: ID
    $description: String
    $notes: String
    $dueDate: Date
  ) {
    saveObjective(
      id: $id
      teamId: $teamId
      description: $description
      notes: $notes
      dueDate: $dueDate
    ) {
      objective {
        ...OBJECTIVE_FRAGMENT
      }
    }
  }
  ${OBJECTIVE_FRAGMENT}
`;

export const DELETE_OBJECTIVE = gql`
  mutation DELETE_OBJECTIVE($id: ID!) {
    deleteObjective(id: $id) {
      id
    }
  }
`;

export const FETCH_TEAMS_FOR_OBJECTIVES = gql`
  query FETCH_TEAMS_FOR_OBJECTIVES($ids: [ID], $year: Int) {
    teams: objectiveTeams(ids: $ids) {
      id
      name
      objectives(year: $year) {
        ...OBJECTIVE_FRAGMENT
      }
    }
  }
  ${OBJECTIVE_FRAGMENT}
`;

export const SAVE_OBJECTIVE_KEY_RESULT = gql`
  mutation SAVE_OBJECTIVE_KEY_RESULT(
    $id: ID
    $objectiveId: ID
    $description: String
    $notes: String
    $dueQuarter: Int
    $weight: Int
    $status: String
  ) {
    saveObjectiveKeyResult(
      id: $id
      objectiveId: $objectiveId
      description: $description
      notes: $notes
      dueQuarter: $dueQuarter
      weight: $weight
      status: $status
    ) {
      keyResult {
        id
        description
        notes
        dueQuarter
        weight
        status
        objective {
          ...OBJECTIVE_FRAGMENT
        }
      }
    }
  }
  ${OBJECTIVE_FRAGMENT}
`;

export const DELETE_OBJECTIVE_KEY_RESULT = gql`
  mutation DELETE_OBJECTIVE_KEY_RESULT($id: ID!) {
    deleteObjectiveKeyResult(id: $id) {
      objective {
        ...OBJECTIVE_FRAGMENT
      }
    }
  }
  ${OBJECTIVE_FRAGMENT}
`;
